import { createElement } from "react";

interface StackProps extends React.PropsWithChildren {
  component?: "div" | "header";
  id?: string;
  className?: string;
  gap?: number;
  direction?: "row" | "column";
  placeItems?: string;
  placeContent?: string;
  style?: React.CSSProperties;
}

const Stack: React.FC<StackProps> = ({
  component = "div",
  className,
  gap = 1,
  direction = "row",
  placeItems,
  placeContent,
  children,
  style,
}) => {
  return createElement(
    component,
    {
      className,
      style: {
        display: "flex",
        flexDirection: direction,
        placeItems,
        placeContent,
        gap: `${gap * 8}px`,
        ...style,
      },
    },
    children
  );
};

export { Stack };
